







































































import { Component, Vue } from 'vue-property-decorator'
import GlobalMixins from '../mixins'
import { bus, zirafHTTP } from '../main'

@Component
export default class Clients extends GlobalMixins {
	private rawClients = []

	get clients() {
		let clients: any[] = this.rawClients

		clients = clients.map((client: any) => {
			return {
				id: client.id,
				name: client.name,
				position: client.position,
				location: client.location,
				active: client.active ? client.testValues ? 'Actief' : 'Niet ingevuld' : 'Inactief'
			}
		})

		if (this.search) {
			clients = clients.filter((client: any) => {
				if (client.name && client.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) return true
				if (client.position && client.position.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) return true
				if (client.location && client.location.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) return true
				if (client.active && client.active.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) return true

				return false
			})
		}

		clients = clients.sort((a: any, b: any) => {
			if (a[this.sortedBy] === b[this.sortedBy]) return 0

			return this.sortDirection === 'normal' ? a[this.sortedBy] > b[this.sortedBy] ? 1 : -1 : a[this.sortedBy] > b[this.sortedBy] ? -1 : 1
		})

		return clients
	}
	get title() {
		if (this.search) {
			return `${this.clients.length} ${this.clients.length === 1 ? 'Klant' : 'Klanten' }`
		} else {
			return 'Klanten'
		}
	}

	mounted() {
		this.sortedBy = 'name'

		zirafHTTP.get('clients')
			.then(response => {
				this.rawClients = response.data

				bus.$emit('initCompleteContent')
			})
			.catch(error => {
				this.checkIfSessionExpired(error.response.data.errorCode, () => {
					console.error(error.response.data)
				})
			})
	}
}
